import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const TeachingIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "teaching",
  "TeachingIcon",
  ["currentColor","white"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><g clipPath="url(#clip0_19498_1272)"><path d="M0.666504 5.96466L8.00022 10.0762L15.3332 5.96466L8.00022 1.85315L0.666504 5.96466ZM3.39303 5.96466L8.00019 8.54757L12.6069 5.96466L8.00019 3.38175L3.39303 5.96466Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M3.33325 8.97186V11.6667V11.931L3.51439 12.1235C4.75242 13.4393 6.32788 14 7.99992 14C9.67196 14 11.2474 13.4393 12.4854 12.1235L12.6666 11.931V11.6667V8.97218L11.3333 9.71976V11.3926C10.4102 12.2766 9.27047 12.6667 7.99992 12.6667C6.72936 12.6667 5.58967 12.2766 4.66659 11.3926V9.71937L3.33325 8.97186Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g><defs><clipPath id="clip0_19498_1272"><rect width="16" height="16" fill={colorList[1]}/></clipPath></defs></g></svg>
);

export default TeachingIcon;
